import AppTabs from './AppTabs';
import DarwinTrafficLightsPlaceholder from './DarwinTrafficLightsPlaceholder';
import TabPanel from './TabPanel';
import TabPanelContent from './TabPanelContent';

export { TabPanel, TabPanelContent, DarwinTrafficLightsPlaceholder };

export default AppTabs;
